const GOOGLE = 'google'
const TWITTER = 'twitter'
const FACEBOOK = 'facebook'
const INSTAGRAM = 'instagram'

const SOCIAL_PROVIDER = { GOOGLE, TWITTER, FACEBOOK, INSTAGRAM }

export { SOCIAL_PROVIDER }
